<div class="ss-page-header">
    <div class="ss-page-header__left">
        <div class="ss-page-header__icon-wrap">
            <i class="fa fa-refresh ss-page-header__icon"></i>
        </div>
        <div>
            <h5 class="ss-page-header__title">Smart Sync</h5>
         
        </div>
    </div>
    <div class="header-actions">
        <button class="icon-btn" (click)="home()" title="Dashboard">
            <i class="fa fa-home"></i>
        </button>
    </div>
</div>

<!-- Tabs -->
<div class="ss-tabs">
    <div class="ss-tabs__item" [class.ss-tabs__item--active]="masterService.smartsyncTabContainer === 'syncVolumeContainer'"
        (click)="showContainer('syncVolumeContainer')">
        <i class="fa fa-line-chart ss-tabs__icon"></i> Sync Volume
    </div>
    <div class="ss-tabs__item" [class.ss-tabs__item--active]="masterService.smartsyncTabContainer === 'syncMOQContainer'"
        (click)="showContainer('syncMOQContainer')">
        <i class="fa fa-cubes ss-tabs__icon"></i> Sync MOQ
    </div>
</div>




<div id="syncVolumeContainer" class="tab-container">
    <form [formGroup]="form">
        <div class="d-flex justify-content-start mt-1">
            <div class="form-group">
                <input type="date" formControlName="fromECDate" class="form-control form-control-lg">
            </div>
            <div class="form-group">
                <input type="date" formControlName="toECDate" class="form-control form-control-lg">
            </div>

            <div class="d-flex justify-content-start">
                <div class="form-group" title="Select Stage">

                    <select id="customerName" name="selectedCurrentStage" class="form-control form-select-lg"
                        aria-label="Select Stage" formControlName="selectedCurrentStage"
                        (change)="onSelectStage($event)">

                        <option value="" disabled selected>Select Stage</option>
       


                        <option *ngFor="let currentstage of dashboardCurrentStage" [value]="currentstage">
                            {{ currentstage }}
                        </option>
                    </select>

                </div>
             <!-- {{form?.value?.selectedCurrentStage | json}}
                {{filteredCustomerList | json}} -->

    <div class="form-group ms-2"
  *ngIf="form.get('fromECDate')?.value && form.get('toECDate')?.value && form?.value?.selectedCurrentStage">
  <label class="content-name">Customer Name</label>


  <ng-select
    #customerSelect
    [items]="filteredCustomerList"
    bindLabel="customer_name"
    bindValue="customer_id"
    [multiple]="true"
    [closeOnSelect]="false"
    [hideSelected]="false"
    [dropdownPosition]="'bottom'"
    formControlName="selectedCustomerIds"
    class="custom-ng-select"
    [searchable]="true"
    [clearable]="true"
    (click)="customerSelect.open()"
    (change)="onCustomerSelectionChange()"
  >

    <!-- Placeholder Text -->
    <ng-template ng-label-tmp let-items="items">
      <div class="custom-placeholder">
        <span *ngIf="!items.length">Select Customer</span>
        <span *ngIf="items.length">{{ items.length }} Customer(s) Selected</span>
      </div>
    </ng-template>

    <!-- Select All Header -->
    <ng-template ng-header-tmp>
      <div class="custom-header">
        <label class="select-all-label">
          <input
            type="checkbox"
            [checked]="isAllCustomersSelected()"
            (change)="toggleSelectAllCustomers($event)"
          />
          Select All
        </label>
      </div>
    </ng-template>

    <!-- Selected Items -->
    <ng-template ng-multi-label-tmp let-items="items">
      <div class="selected-items">
        <span *ngFor="let item of items" class="selected-item">
          {{ item.customer_name }}
        </span>
      </div>
    </ng-template>
  </ng-select>
</div>

<!-- {{projectNameDetails | json}} -->
<div class="d-flex justify-content-between">
                    <ng-container
                        *ngIf="form.get('fromECDate')?.value && form.get('toECDate')?.value && form.get('selectedCurrentStage')?.value">
                        <label class="content-name">Project Name</label>
                        <ng-select #projectSelect [items]="projectNameDetails" bindLabel="projectName"
                            bindValue="project_id" [multiple]="true" [closeOnSelect]="false" [hideSelected]="false"
                            [dropdownPosition]="'bottom'" formControlName="selectedProjectId" class="custom-ng-select"
                            (click)="projectSelect.open()" [searchable]="true" [clearable]="true">

                            <ng-template ng-label-tmp let-items="items">
                                <div class="custom-placeholder">
                                    <span *ngIf="!items.length">Select Project</span>
                                    <span *ngIf="items.length">{{ items.length }} Project(s) Selected</span>
                                </div>
                            </ng-template>

                            <ng-template ng-header-tmp>
                                <div class="custom-header">
                                    <label class="select-all-label">
                                        <input type="checkbox" [checked]="isAllSelected()"
                                            (change)="toggleSelectAll($event)" />
                                        Select All
                                    </label>
                                </div>
                            </ng-template>

                            <ng-template ng-multi-label-tmp let-items="items">
                                <div class="selected-items">
                                    <span *ngFor="let item of items" class="selected-item">
                                        {{ item.projectName }}
                                    </span>
                                </div>
                            </ng-template>
                        </ng-select>
                    </ng-container>


                </div>
            </div>

            <div class="ss-action-bar">
                <button class="ss-filter-btn ss-filter-btn--primary"
                    (click)="smartsyncFilter()" [disabled]="form.invalid">
                    <i class="fa fa-filter ss-filter-btn__icon"></i> Filter
                </button>
                <button class="ss-filter-btn ss-filter-btn--outline"
                    (click)="clearFilters()">
                    <i class="fa fa-undo ss-filter-btn__icon"></i> Reset
                </button>
                <button class="ss-filter-btn ss-filter-btn--accent"
                    *ngIf="this.masterService.smartsyncTabContainer === 'syncMOQContainer' && this.masterService.showMOQSection"
                    (click)="fetchDetails()" [disabled]="form.invalid">
                    <i class="fa fa-download ss-filter-btn__icon"></i> Fetch MOQ
                </button>
            </div>
       

        </div>
    </form>
    <div *ngIf="this.masterService.smartsyncTabContainer  === 'syncVolumeContainer'&& showTable"
        class="col-12 grid-margin stretch-card col_pad mt-1">
        <div class="card">
            <div class="card-body">
                <div class="table-responsive gd_main_div_mobile">
                    <table class="table table-striped custom-hover">
                        <thead>
                            <tr>
                                <th>MPN</th>
                                <th>UOM </th>
                                <th>Gross Quantity</th>
                                <th *ngIf="userRole === 'Manager'">Engineer Name</th>
                                <th>Project Name</th>
                                <th>Current Stage</th>
                                <th>Internal Part No.</th>
                                <th>Quantity</th>
                                <th>E.C.Date</th>
                                <th>Supplier</th>
                                <th>Stock</th>
                                <th>Price</th>
                                <th>Currency</th>
                                <th>MOQ</th>
                                <th>LT</th>
                                <th>Difference</th>
                                <th>Action</th>
                                <th *ngIf="userRole === 'Manager'">Assigned To</th>
                            </tr>
                        </thead>

                        <tbody>
                            <ng-container *ngFor="let row of filteredData">
                                <ng-container *ngFor="let detail of row.details; let j = index">
                                    <tr>

                                        <td *ngIf="j === 0" [attr.rowspan]="row.details.length" class="partNo_td"
                                            (click)="onpartsync(row,row.details)" title="{{ detail?.MPN }}">
                                            {{ detail?.MPN }}
                                        </td>

                                        <td *ngIf="j === 0" [attr.rowspan]="row.details.length"
                                            title="{{ detail?.uom }}">
                                            {{ detail?.uom }}
                                        </td>
                                        <td *ngIf="j === 0" [attr.rowspan]="row.details.length"
                                            title="{{ row?.header?.GrossprojectQty }}">
                                            {{ row?.header?.GrossprojectQty }}
                                        </td>

                                        <ng-container *ngIf="row.expanded">

                                            <td *ngIf="userRole === 'Manager'" title="{{ detail?.engineer_name }}">{{
                                                detail?.engineer_name }}
                                            </td>
                                            <td title="{{ detail?.projectName }}">{{ detail?.projectName }}</td>
                                            <td title="{{ detail?.currentStage }}">{{ detail?.currentStage }}</td>
                                            <td title="{{ detail?.internalPartNo }}">{{ detail?.internalPartNo }}</td>
                                            <td title="{{ detail?.projectQty }}">{{ detail?.projectQty }}</td>
                                            <td title="{{ detail?.expectedCompletionDate}}">{{
                                                detail?.expectedCompletionDate }}
                                            </td>
                                            <td title="{{ detail?.supplier }}">{{ detail?.supplier }}</td>
                                            <td title="{{ detail?.Inventorylevel }}">{{ detail?.Inventorylevel }}
                                            </td>
                                            <td title="{{ detail?.Price }}">{{ detail?.Price }}</td>
                                            <td title="{{ detail?.Currency }}">{{ detail?.Currency }}</td>
                                            <td title="{{ detail?.Closest_Quantity }}">{{ detail?.Closest_Quantity }}
                                            </td>
                                            <td title="{{ detail?.estimatedFactoryLeadDays }}">{{
                                                detail?.estimatedFactoryLeadDays }}</td>
                                            <td title="{{ detail?.QuantityDiff }}">{{ detail?.QuantityDiff }}</td>
                                        </ng-container>
                                        <td *ngIf="j === 0" [attr.rowspan]="row.details.length">
                                            <i class="fa-solid" [ngClass]="row.expanded ? 'fa-minus' : 'fa-plus'"
                                                (click)="toggleExpand(row)"></i>
                                        </td>
                                        <td *ngIf="userRole === 'Manager'" title="{{ detail?.assignedTo }}">
                                            {{ detail?.assignedTo }}
                                        </td>
                                    </tr>
                                </ng-container>
                            </ng-container>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>


    <div *ngIf="this.masterService.smartsyncTabContainer  === 'syncMOQContainer'  && this.masterService.showMOQSection"
        class="col-12 grid-margin stretch-card col_pad mt-1">
        <div class="card">
            <div class="card-body">
                <div class="table-responsive gd_main_div_mobile">
                    <table class="table table-striped custom-hover">
                        <thead>
                            <tr>
                                <th>Manufacturing Part No</th>
                                <th>Internal Part No </th>
                                <th>Required Quantity</th>
                                <th>Project Name</th>
                                <th>Selected Supplier</th>
                                <th>Stock</th>
                                <th>Price</th>
                                <th>Currency</th>
                                <th>Converted Price</th>
                                <th>SPQ</th>
                                <th>MOQ</th>
                                <th>QuantityDiff</th>
                                <th>Total Cost</th>
                                <th>MOQ Cost</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let row of masterService.FinalMoqData; let i = index">
                                <td>{{ row?.MPN }}</td>
                                <td>{{ row?.internalPartNo }}</td>
                                <td>{{ row?.RequiredQuantity }}</td>
                                <td>{{ row?.projectName }}</td>
                                <td>{{ row?.selectedSupplier }}</td>
                                <td>{{ row?.Inventorylevel }}</td>
                                <td>{{ row?.Price }}</td>
                                <td>{{ row?.Currency }}</td>
                                <td>{{ row?.ConvertedPrice }}</td>
                                <td>{{ row?.Closest_Quantity}}</td>
                                <td>{{ row?.MOQ }}</td>
                                <td>{{ row?.quantityDiff }}</td>
                                <td>{{ row?.totalCost }}</td>
                                <td>{{ row?.moqCost}}</td>

                                <td>
                                    <input type="checkbox" [checked]="isSelected(i)" (change)="toggleSelection(i)" />
                                </td>

                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
</div>

<!-- Ambient Top Shimmer Bar -->
<div *ngIf="isLoading" class="loading-bar"></div>

<!-- Super Modern Loading Overlay -->
<div *ngIf="isLoading" class="sb-loading-overlay">
  <div class="sb-loading-card">
    <div class="sb-spinner-container">
      <div class="sb-spinner-ring"></div>
      <div class="sb-spinner-ring-inner"></div>
      <div class="sb-spinner-core">
        <i class="fa fa-line-chart sb-spinner-icon"></i>
      </div>
    </div>
    <div class="sb-loading-content">
      <h4 class="sb-loading-title">{{ loadingTitle }}</h4>
      <p class="sb-loading-subtitle">{{ loadingSubtitle }}</p>
    </div>
    <div class="sb-loading-progress-bar">
      <div class="sb-loading-progress-indeterminate"></div>
    </div>
  </div>
</div>
